import { PageHeader } from '@/components/PageHeader';
import { Button } from '@predoc/cow';
import { ClipboardPlus } from 'lucide-react';
import { useNavigate } from 'react-router';
import { PatientsList } from './patient-list';
import { usePageTitle } from '@/hooks';

export const PatientsPage = () => {
  usePageTitle('Patients');
  const navigate = useNavigate();

  const handleNewPatientRequest = () => {
    navigate('/patients/request');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader>
        <h1 className="text-3xl font-bold">Patients</h1>
        <Button variant="default" onClick={handleNewPatientRequest}>
          <ClipboardPlus className="size-4" />
          New Patient Request
        </Button>
      </PageHeader>
      <PatientsList />
    </div>
  );
};
